import { connect } from 'react-redux';
import { compose } from 'redux';
import _range from 'lodash/range';
import { withOpportunityShownTracking } from 'helpers/events';

import ClassRow from './ClassRow';

const mapStateToProps = (_, ownProps) => {
  const { opportunity } = ownProps;
  const { networkSpotsAllocated, recommendation, totalCapacity, totalReservations } = opportunity;

  const availabilityDropdownRange = _range(
    0,
    (totalCapacity || networkSpotsAllocated + recommendation) - (totalReservations || 0) + 1
  );

  return {
    availabilityDropdownRange,
  };
};

export default compose(withOpportunityShownTracking, connect(mapStateToProps))(ClassRow);
